<template>
  <div>
    <v-dialog v-if="popup.show" v-model="popup.show" width="512">
      <v-card>
        <v-btn
          depressed
          absolute
          @click="popup.show = false"
          style="z-index: 1"
          icon
          ><v-icon>mdi-close</v-icon></v-btn
        >
        <a
          :href="popup.url"
          :style="popup.url ? 'cursor:pointer' : 'cursor:auto'"
        >
          <v-img max-height="512" max-width="512" :src="popup.urlImg">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </a>
      </v-card>
    </v-dialog>

    <v-responsive
      v-if="!(loading === false && slides.length === 0)"
      :aspect-ratio="aspectRatioResponsive"
      v-show="vrespBlock"
      :class="{
        'px-1 pb-2': onCasinoLobby,
        'px-6': onCasinoLobby && $vuetify.breakpoint.mobile,
      }"
    >
      <v-skeleton-loader
        height="100%"
        v-show="loading"
        type="image"
        class="v-skeleton-loader__image"
      ></v-skeleton-loader>
      <v-carousel
        v-show="!loading"
        v-model="model"
        interval="6000"
        hide-delimiter-background
        progress
        cycle
        continuous
        height="auto"
        :style="$vuetify.breakpoint.smAndDown ? '' : 'border-radius: 4px'"
        :show-arrows="$vuetify.breakpoint.xs ? false : true"
        :show-arrows-on-hover="$vuetify.breakpoint.xs ? false : true"
      >
        <v-carousel-item
          v-for="(slide, i) in slides"
          :key="`slide-${i}`"
          :href="slide.url"
        >
          <v-img
            :src="slide.urlImg"
            @load="handlerAspectRatio"
            :aspect-ratio="aspectRatio"
          />
        </v-carousel-item>
      </v-carousel>
    </v-responsive>
  </div>
</template>

<script>
import axios from "axios";
const baseUrlS3 = "https://dozr8la71aog.cloudfront.net/";
export default {
  name: "carousel",
  data: () => {
    return {
      model: 0,
      carousel: false,
      slides: [],
      popup: { show: false, urlImg: "", url: "#" },
      loading: true,
      aspectRatioResponsive: "3",
      aspectRatio: "",
      vrespBlock: true,
    };
  },
  async mounted() {
    this.loading = true;

    const body = {
      domain: this.$domain(),
    };

    const casinoLobby = this.onCasinoLobby;
    if (casinoLobby) {
      body.casino = true;
    }

    const baseLambdaUrl = this.$newCarouselAndPopupLambdaUrl();

    const headers = {
      "Content-Type": "application/json",
    };

    const carouselType = casinoLobby
      ? "carouselImagesCasino"
      : "carouselImages";

    const { isExpired, data } = await this.$localbase.get({
      type: carouselType,
    });

    if (!isExpired && data) {
      this.slides = data;
      if (data.length === 0) {
        this.carousel = false;
        this.vrespBlock = false;
      }
      setTimeout(() => {
        this.loading = false;
      }, 300);
      return;
    }

    // Consume CAROUSEL
    const urlCarousel = `${baseLambdaUrl}/listImagesCarousel`;
    await axios
      .post(`${urlCarousel}`, body, { headers: headers })
      .then((resp) => {
        const contents = resp.data;
        if (contents.length === 0) {
          this.carousel = false;
          this.vrespBlock = false;
        }
        this.slides = contents
          .filter((image) => image.Size > 0)
          .map((image) => {
            let urlImg = baseUrlS3 + encodeURIComponent(image.Key);
            let url = this.$constructURL(image.Key);
            return { urlImg, url };
          });

        this.$localbase.set({ type: carouselType, data: this.slides });
      })
      .catch(() => (this.carousel = false))
      .finally(() => (this.loading = false));

    const popupType = `popup-${casinoLobby ? "casino" : "sports"}`;

    // // Consume POP-UP
    if (sessionStorage.getItem(popupType)) return;
    const urlPopUp = `${baseLambdaUrl}/listImagesPopUp`;
    axios
      .post(`${urlPopUp}`, body, { headers: headers })
      .then((resp) => {
        const contents = resp.data;
        if (contents.length === 0) return;
        this.popup.urlImg = baseUrlS3 + encodeURIComponent(contents[0].Key);
        this.popup.url = this.$constructURL(contents[0].Key);
        sessionStorage.setItem("popup", true);
        setTimeout(() => (this.popup.show = true), 2000);
      })
      .catch(() => sessionStorage.setItem(popupType, false));
  },
  computed: {
    onCasinoLobby() {
      return this.$route.name === "casinoLobby";
    },
  },
  methods: {
    handlerAspectRatio(imgUrl) {
      let img = new Image();
      img.src = imgUrl;
      if (!this.aspectRatio) {
        var aspectRatio = Number((img.width / img.height).toFixed(2));
        this.aspectRatio = aspectRatio;
        this.aspectRatioResponsive = aspectRatio;
      }
    },
  },
};
</script>
<style>
.v-skeleton-loader__image {
  border-radius: 4px;
  height: 100%;
}
</style>
